// extracted by mini-css-extract-plugin
export default {"circuitDetail":"index_circuitDetail__cmXSM","title":"index_title__RF5jJ","rightDrawer":"index_rightDrawer__PTXAq","text":"index_text__Li3ot"};